module.exports = __webpack_public_path__ + "img/play.a56ce786.svg";